import { render } from "./ClassLearnersRecords.vue?vue&type=template&id=2ca485e1"
import script from "./ClassLearnersRecords.vue?vue&type=script&lang=js"
export * from "./ClassLearnersRecords.vue?vue&type=script&lang=js"

import "./ClassLearnersRecords.vue?vue&type=style&index=0&id=2ca485e1&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__